import { type Cue, type Voice, voiceFor } from "./cue.ts";

export type Who = "human" | "agent" | null;

export type Happening =
  | { what: "said"; conversation: string; by: Who; addressed: boolean; mine: boolean }
  | { what: "turn ended"; conversation: string }
  | { what: "turn waiting"; conversation: string }
  | { what: "ringing"; conversation: string; call: string; by: Who }
  | { what: "joined a call"; conversation: string; call: string; by: Who; mine: boolean }
  | { what: "left a call"; conversation: string; call: string; by: Who; mine: boolean }
  | { what: "call ended"; conversation: string; call: string }
  | { what: "recording began"; conversation: string; call: string }
  | { what: "send failed"; conversation: string };

export function cueOf(happening: Happening): Cue {
  switch (happening.what) {
    case "said":
      return happening.addressed ? "mention" : "message";
    case "turn ended":
      return "agentDone";
    case "turn waiting":
      return "agentNeedsYou";
    case "ringing":
      return "ringing";
    case "joined a call":
      return happening.mine ? "youJoined" : "somebodyJoined";
    case "left a call":
      return "somebodyLeft";
    case "call ended":
      return "callEnded";
    case "recording began":
      return "recordingStarted";
    case "send failed":
      return "sendFailed";
  }
}

export function whoOf(happening: Happening): Who {
  if (happening.what === "turn ended" || happening.what === "turn waiting") return "agent";
  return "by" in happening ? happening.by : null;
}

export function voiceOf(happening: Happening): Voice {
  return voiceFor(cueOf(happening), whoOf(happening));
}

export function mineIn(happening: Happening): boolean {
  if (happening.what === "send failed") return true;
  return "mine" in happening ? happening.mine : false;
}

export function chosen(happening: Happening): { cue: Cue; voice: Voice; mine: boolean } {
  return { cue: cueOf(happening), voice: voiceOf(happening), mine: mineIn(happening) };
}
